import styled from "styled-components";
import { sizeMap, borderRadiusMap, borderShadowMap} from '../config'


export const Main = styled.div`
    background: ${({content}) => content.mainBgColor};
    color: ${({content}) => content.mainTextColor};
    padding: 5px;
    h1 {
        font-weight: 300;
        font-size: 1.5rem;
    }

    h2 {
        font-weight: 300;
        font-size: 1.5rem;
    }
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: ${({content}) => borderRadiusMap[content.roundTextBoxEdges]};
`;

export const Body = styled.div`
    padding: ${({content}) => (content.smallWindow )? '5px': '25px'};
    
`;


export const Box = styled.div`
    background: ${({content}) => content.textBoxBgColor};
    color: ${({content}) => content.textBoxTextColor};
    font-weight: 300;
    padding: 0px;
    border: 1px solid ${({content}) => content.textBoxBorderColor};
    border-radius: ${({content}) => borderRadiusMap[content.roundTextBoxEdges]};
    box-shadow: 0 ${({content}) => borderShadowMap[content.textBoxShadows]} ${({content}) => content.textBoxBorderColor};
    strong {color: ${({content}) => content.textBoxHighlightColor};}
    h3 {color: ${({content}) => content.textBoxHighlightColor};
        font-weight: 300;
        font-size: 1.5rem;
        }
    h4 {font-weight: 300;
        font-size: 1rem;
        color: ${({content}) => content.textBoxHighlightColor}
        }
    hr {border: 1px solid ${({content}) => content.textBoxHighlightColor}};
`;

export const AboutBody = styled.div`
    padding: ${({content}) => (content.smallWindow )? '5px': '25px'};
    display: flex;
    column-gap: 20px;
    row-gap: 20px;
    justify-content: space-between;
    flex-wrap: wrap;    
`;

export const AboutBox = styled.div`
    background: ${({content}) => content.textBoxBgColor};
    color: ${({content}) => content.textBoxTextColor};
    font-weight: 300;
    padding: 0px;
    width: ${({content}) => sizeMap[content.maxBoxWidth]};    
    border: 1px solid ${({content}) => content.textBoxBorderColor};
    border-radius: ${({content}) => borderRadiusMap[content.roundTextBoxEdges]};
    box-shadow: 0 ${({content}) => borderShadowMap[content.textBoxShadows]} ${({content}) => content.textBoxBorderColor};
    strong {color: ${({content}) => content.textBoxHighlightColor};}
    h3 {color: ${({content}) => content.textBoxHighlightColor};
        font-weight: 300;
        font-size: 1.5rem;
        }
    h4 {font-weight: 300;
        font-size: 1rem;
        color: ${({content}) => content.textBoxHighlightColor}
        }
    hr {border: 1px solid ${({content}) => content.textBoxHighlightColor}};
`;


export const ImageBox = styled.div`
    background: ${({content}) => content.BgColor};
    padding: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const LinkImageBox = styled.div`
    background: ${({content}) => content.BgColor};
    padding: 0px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
`;

export const TextBox = styled.div`
    padding: 10px;   
    overflow-wrap: break-word;
    th {text-align: left};
`;

export const Nav = styled.div `
    a.active  { color: ${({content}) => content.textBoxHighlightColor}; }
    a { color: ${({content}) => content.textBoxTextColor}; }
`;